export const STATUS_OK: number = 200
export const STATUS_NO_CONTENT: number = 204
export const STATUS_BAD_REQUEST: number = 400
export const STATUS_UNAUTHORIZED: number = 401
export const STATUS_FORBIDDEN: number = 403
export const STATUS_NOT_FOUND: number = 404
export const STATUS_CONFLICT: number = 409
export const STATUS_TOO_MANY_REQUESTS: number = 429
